var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { css } from "styled-components";
import { map } from "../../breakpoint";
import { m, mx, my, mt, mb, ml, mr } from "../../spacing"; // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types

export var margins = function margins(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
    var margin = _ref.margin;
    return map(margin, function (val) {
      return val !== undefined && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          ", ";\n        "])), m(val));
    });
  }, function (_ref2) {
    var marginHorizontal = _ref2.marginHorizontal;
    return map(marginHorizontal, function (val) {
      return val !== undefined && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          ", ";\n        "])), mx(val));
    });
  }, function (_ref3) {
    var marginVertical = _ref3.marginVertical;
    return map(marginVertical, function (val) {
      return val !== undefined && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          ", ";\n        "])), my(val));
    });
  }, function (_ref4) {
    var marginTop = _ref4.marginTop;
    return map(marginTop, function (val) {
      return val !== undefined && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n          ", ";\n        "])), mt(val));
    });
  }, function (_ref5) {
    var marginBottom = _ref5.marginBottom;
    return map(marginBottom, function (val) {
      return val !== undefined && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          ", ";\n        "])), mb(val));
    });
  }, function (_ref6) {
    var marginLeft = _ref6.marginLeft;
    return map(marginLeft, function (val) {
      return val !== undefined && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          ", ";\n        "])), ml(val));
    });
  }, function (_ref7) {
    var marginRight = _ref7.marginRight;
    return map(marginRight, function (val) {
      return val !== undefined && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          ", ";\n        "])), mr(val));
    });
  });
};